import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
/**
 * A value is a number that can be positive, negative or neutral (0).
 *
 * @return {jsx}
 */

/* eslint-disable no-unused-vars */

var Value = function Value(_ref) {
  var children = _ref.children,
      className = _ref.className,
      positive = _ref.positive,
      negative = _ref.negative;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, children);
};
/**
 * PropTypes Validation
 */


var bool = PropTypes.bool,
    node = PropTypes.node,
    string = PropTypes.string;
Value.propTypes = {
  /** Anything that can be rendered: numbers, strings, elements or an array (or fragment) */
  children: node,

  /** className needed by styled-components */
  className: string,

  /** If the value is positive  */
  positive: bool,

  /** If the value is negative */
  negative: bool
};
/**
 * Default props
 */

Value.defaultProps = {
  children: null,
  className: '',
  positive: false,
  negative: false
};
export default styled(Value).withConfig({
  displayName: "Value",
  componentId: "sc-174z8jd-0"
})(["color:", ";", ";", ";"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.darkBlue;
}, function (_ref3) {
  var negative = _ref3.negative;
  return negative && css(["color:", ";"], function (_ref4) {
    var palette = _ref4.theme.palette;
    return palette.failure["default"];
  });
}, function (_ref5) {
  var positive = _ref5.positive;
  return positive && css(["color:", ";"], function (_ref6) {
    var palette = _ref6.theme.palette;
    return palette.success["default"];
  });
});